import { render, staticRenderFns } from "./HandAmount.vue?vue&type=template&id=f50d9250"
import script from "./HandAmount.vue?vue&type=script&lang=js"
export * from "./HandAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports